'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";

import {FaExclamationCircle} from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";

import ProgressBar from 'react-bootstrap/ProgressBar';
import Card from 'react-bootstrap/Card';
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";
import {withRouter} from "@uw-it-sis/lib-react/lib/WithRouter";

import preRegWorkflowStore from "./PreRegWorkflowStore";
import {
    Meningitis as meningo,
    VoterRegistration as voter,
    Riaa as riaa,
    Clery as clery,
    Upass as upass,
    FinancialResponsibility as finliab,
    Ferpa as ferpa, Meningitis, VoterRegistration, Riaa, Clery, Upass, FinancialResponsibility, Ferpa
} from "./Acknowledgements";

import OpChargeUpass from "./OpChargeUpass";
import OpChargeInsurance from "./OpChargeInsurance";
import OpChargeWashPIRG from "./OpChargeWashPIRG";
import OpChargeUSAS from "./OpChargeUSAS";
import OpChargeWSA from "./OpChargeWSA";
import OpChargeASUW from "./OpChargeASUW";
import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';


class PreRegWorkflow extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = preRegWorkflowStore;
        this.seamlessRegEnabled = appStore.getAppAttribute("seamless_reg_enabled");
        this.steps = [];

        this.state = {
            step: 0
        }

        if (!this.props.termId && this.props.hasOwnProperty("params") && this.props.params.hasOwnProperty("identifier")) {
            const identifier = this.props.params.identifier;
            this.termId = TermUtils.makeTermIdFromTermName(identifier);
        } else {
            this.termId = this.props.termId;
        }
    }

    componentDidMount() {
        if (this.seamlessRegEnabled) {
            this.store.mount(this.props.onSuccess, this.termId);
        }
    }

    incrementStep = () => {
        this.setState({step: ++this.state.step});
    }

    decrementStep = () => {
        this.setState({step: --this.state.step});
    }

    savePreReg = () => {
        this.store.savePreReg();
    }

    buildDoneComponent() {
        let campus;

        if (this.steps.length === 0) {
            const requiredAcknowledgements = this.store.getRequiredAcknowledgements();
            // variables used throughout page
            const termName = TermUtils.makeTermDescriptionFromTermId(this.termId);
            const optChargesData = this.store.getOptChargesData();

            switch (parseInt(optChargesData.branch_code)) {
                case 0:
                    campus = Campus.seattle;
                    break;
                case 1:
                    campus = Campus.bothell;
                    break;
                case 2:
                    campus = Campus.tacoma;
                    break;
            }

            requiredAcknowledgements.map(([componentKey, accepted], index) => {
                switch (componentKey) {
                    case "meningo":
                        this.steps.push(<Meningitis updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;
                    case "voter":
                        this.steps.push(<VoterRegistration updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;
                    case "riaa":
                        this.steps.push(<Riaa updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;
                    case "clery":
                        this.steps.push(<Clery updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;
                    case "upass":
                        this.steps.push(<Upass updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;
                    case "finliab":
                        this.steps.push(<FinancialResponsibility updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;
                    case "ferpa":
                        this.steps.push(<Ferpa updateAcknowledgement={this.store.updateAcknowledgement} onSuccess={this.incrementStep} key={index} />)
                        break;

                }
            });

            if (optChargesData.show.opChargeUpass) {
                this.steps.push(<OpChargeUpass campus={campus} onSuccess={this.incrementStep} showButton />);
            }

            if (optChargesData.show.opChargeWashPIRG) {
                this.steps.push(<OpChargeWashPIRG campus={campus} onSuccess={this.incrementStep} showButton />);
            }

            if (optChargesData.show.opChargeUSAS) {
                this.steps.push(<OpChargeUSAS campus={campus} onSuccess={this.incrementStep} showButton />);
            }

            if (optChargesData.show.opChargeWSA) {
                this.steps.push(<OpChargeWSA campus={campus} onSuccess={this.incrementStep} showButton />);
            }

            if (optChargesData.show.opChargeASUW) {
                this.steps.push(<OpChargeASUW campus={campus} onSuccess={this.incrementStep} showButton />);
            }

            if (optChargesData.show.opChargeInsurance) {
                this.steps.push(<OpChargeInsurance termId={this.termId} termName={termName} campus={campus} onSuccess={this.incrementStep} showButton />);
            }
        }

        if (this.steps.length === 0) {
            return (
                <Alert variant="info" className="d-inline-flex align-items-center">
                    <FaInfoCircle className="me-3 fs-5" aria-hidden={true} />
                    <div>You currently have no pre registration items to complete.</div>
                </Alert>
            )
        }

        let backButton;
        if (this.state.step !== 0) {
            backButton = <Button variant="link" onClick={this.decrementStep}>Back</Button>
        }

        let now = ( (this.state.step + 1) / (this.steps.length + 1) ) * 100;

        let component;
        if (this.steps.length === this.state.step) {
            component =
                <Card>
                    <Card.Header as="h1" className="h3">Complete Pre Registration</Card.Header>
                    <Card.Body>
                        <Card.Text>
                            Save your selections and complete your pre registration.
                        </Card.Text>
                        <div className="d-flex space-x-3">
                            <Button variant="primary" onClick={this.savePreReg}>Save</Button>
                            {backButton}
                        </div>
                    </Card.Body>
                </Card>
        } else {
            component =
                <>
                    {this.steps[this.state.step]}
                    {backButton}
                </>
        }
        return (
            <>
                <div className="mb-4">
                    <ProgressBar now={now} label={`${this.steps.length === this.state.step ? this.state.step : this.state.step + 1} of ${this.steps.length}`} />
                </div>
                {component}
            </>
        );
    }

    render() {
        if (!this.seamlessRegEnabled) {
            return (
                <Alert variant="danger" className="d-inline-flex align-items-center">
                    <FaExclamationCircle className="me-3 fs-5" aria-hidden={true} />
                    <div>This page is not currently accessible.</div>
                </Alert>
            )
        } else {
            return (
                <SimpleState state={this.store.state}
                             doneComponentBuilder={() => this.buildDoneComponent()}
                             pendingComponentBuilder="dots"
                             name="PreRegWorkflow" />
            )
        }
    }
}

PreRegWorkflow.propTypes = {
    onSuccess: PropTypes.func,
    isAfterRegDate: PropTypes.bool,
    termId: PropTypes.string
}

PreRegWorkflow.defaultProps = {
    onSuccess: () => {}
}

export default withRouter(observer(PreRegWorkflow));